import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import ColorPicker from "@/pages/design/components/ColorPicker";
import InputBar from "@/pages/design/components/InputBar";
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    CardItem: CardItem,
    ColorPicker: ColorPicker,
    InputBar: InputBar
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      locationClient: [{
        label: this.$t('form.mobile'),
        value: 2
      }, {
        label: this.$t('form.pc'),
        value: 1
      }]
    };
  }
};